"use strict";

function remove(array, object) {
  var idx = array.indexOf(object);

  if(idx !== -1) {
    array.splice(idx, 1);
  }
}
UploadTracker.$inject = ["$rootScope", "$q", "Upload"];
function UploadTracker($rootScope, $q, Upload) {
  var queue = [];

  function maybeApplyEmit(event, upload, error) {
    if($rootScope.$$phase) {
      $rootScope.$emit(event, upload, error || null);
    }
    else {
      $rootScope.$apply(function() {
        $rootScope.$emit(event, upload, error || null);
      });
    }
  }

  function enqueue(file) {
    file.fileFormDataName = "files";

    var upload = Upload.upload(file);

    upload.uploadName   = file.file.name;
    upload.uploadStatus = "INPROGRESS";
    upload.uploadLoaded = 0;
    upload.uploadTotal  = 0;

    upload.then(function() {
      remove(queue, upload);

      upload.uploadStatus = "COMPLETE";

      maybeApplyEmit("file-upload.complete", upload);
    }, function(error) {
      remove(queue, upload);

      upload.uploadError  = error;
      upload.uploadStatus = "ERROR";

      maybeApplyEmit("file-upload.error", upload, error);
    });

    queue.push(upload);

    maybeApplyEmit("file-upload.start", upload);

    return upload;
  }

  function onProgress(upload, event) {
    upload.uploadStatus = "INPROGRESS";
    upload.uploadLoaded = event.loaded;
    upload.uploadTotal  = event.total;

    maybeApplyEmit("file-upload.progress", upload);
  }

  return function(uploadData) {
    var deferred = $q.defer();
    var complete = [];

    if( ! Array.isArray(uploadData)) {
      uploadData = [uploadData];
    }

    var uploads = uploadData.map(function(f) {
      var u = enqueue(f);

      function onEnd() {
        remove(uploads, u);

        if(uploads.length === 0) {
          deferred.resolve(complete);
        }
      }

      u.success(function(data, status, headers) {
        complete.push(headers("Location"));

        onEnd(u);
      });

      u.error(onEnd);

      u.progress(function(event) {
        onProgress(u, event);
      });

      return u;
    });

    deferred.promise.abort = function() {
      uploads.forEach(function(u) {
        u.abort();
      });
    };

    return deferred.promise;
  };
}

angular.module("dokiv")
  .factory("UploadTracker", UploadTracker);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/UploadTracker.js
// module id = 254
// module chunks = 0